<template>
  <div class="d-contents">
    <component
      :is="component(block.type)"
      v-for="(block, key) in blocks"
      :key="key"
      :data="block.data"
    />
  </div>
</template>

<script>
  import Paragraph from '@/components/editorjs/Paragraph';

  export default {
    name: 'EditorBlocks',
    props: {
      blocks: {
        type: Array,
        required: true,
      },
    },
    methods: {
      component(type) {
        return this.componentByType?.[type] || Paragraph;
      },
    },
    data() {
      return {
        componentByType: {
          paragraph: Paragraph,
          default: Paragraph,
        },
      };
    },
  };
</script>
